import { combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "../services/apiSlice";
import authReducer from "./authSlice";
import categoryFilterReducer from "./categorySlice";
import orderFilterReducer from "./order/orderFilterSlice";
import cancellationFilterReducer from "./cancellation/cancellationFilterSlice";
import refundFilterReducer from "./refund/refundFilterSlice";
import modalReducer from "./modalSlice";
import productListReducer from "./productListFilterSlice";
import bulkSparesFilterReducer from "./bulk/bulkSparesFilterSlice";
import bulkSparesLotFilterReducer from "./bulk/bulkSparesLotFilterSlice";
import inventorySpareFilterreducer from "./inventory/inventorySparesSlice";



import inventorySpareLotListFilterReducer from "./inventory/inventorySpareLotListSlice";

const appReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
  categoryFilter: categoryFilterReducer,
  refundFilter: refundFilterReducer,
  cancellationFilter: cancellationFilterReducer,
  inventorySpareFilter: inventorySpareFilterreducer,
  
  inventorySpareLotListFilter: inventorySpareLotListFilterReducer,
  bulkSparesFilter: bulkSparesFilterReducer,
  bulkSparesLotFilter:bulkSparesLotFilterReducer,

  orderFilter: orderFilterReducer,
  productListFilter: productListReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export default appReducer;
